import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  select(event) {
    const name = event.currentTarget.dataset.tabName

    this.tabTargets.forEach((tab) => tab.classList.toggle("is-active", tab.dataset.tabName === name))
    this.panelTargets.forEach((panel) => panel.hidden = panel.dataset.tabName !== name)
  }
}
